export default "__VITE_ASSET__UOjD0lj___"